import { useState } from 'react'
import PhoneInput from '@components/ui/PhoneInput'
import styles from './ServiceRequest.module.css'

const services = [
  'Site Visit',
  'Heat Load Calculation',
  'Planning & Layouting',
  'Refrigerant Pipes',
  'Pressure Testing',
  'Final Delivery',
]

const ServiceRequest = () => {
  const [formData, setFormData] = useState({
    personName: '',
    companyName: '',
    phone: '',
    email: '',
    address: '',
    service: '',
    other: '',
    visitTime: '',
  })

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.card}>
            <div className={styles.imageWrapper}>
              <div className={styles.imagePlaceholder} />
            </div>
            <h3 className={styles.cardTitle}>Raise a Service Request!</h3>
            <p className={styles.cardText}>
              You are just a few details away from getting an exceptional HVAC
              Solution!
            </p>
          </div>
        </div>
        <div className={styles.right}>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.field}>
              <label className={styles.label}>Person Name *</label>
              <input
                type="text"
                name="personName"
                className={styles.input}
                placeholder="Enter your full name"
                value={formData.personName}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Company name *</label>
              <input
                type="text"
                name="companyName"
                className={styles.input}
                placeholder="Enter Company name"
                value={formData.companyName}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Contact Number *</label>
              <PhoneInput
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                placeholder="Enter your phone number"
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Contact Email</label>
              <input
                type="email"
                name="email"
                className={styles.input}
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Company Address *</label>
              <input
                type="text"
                name="address"
                className={styles.input}
                placeholder="Enter your address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Required Service *</label>
              <select
                name="service"
                className={styles.select}
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Choose one</option>
                {services.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div className={styles.field}>
              <label className={styles.label}>
                Other ( Mention the Problem you are facing )
              </label>
              <input
                type="text"
                name="other"
                className={styles.input}
                value={formData.other}
                onChange={handleChange}
              />
            </div>
            <div className={styles.field}>
              <label className={styles.label}>Preferred Visit Timings *</label>
              <input
                type="time"
                name="visitTime"
                className={styles.input}
                placeholder="HH:MM AM"
                value={formData.visitTime}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className={styles.submit}>
              Submit
            </button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default ServiceRequest
